import config from '../../../../config/config';
import { ArcGISApi, Configuration } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const arcgisProxyApi = new ArcGISApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
